"use strict";
exports.__esModule = true;
exports.nativePaymentResult = exports.nativePaymentsAvailable = exports.requestPayment = exports.requestNativePaymentsAvailable = void 0;
var t = require("io-ts");
var createReqRes_1 = require("../request-handler/createReqRes");
var basic_1 = require("./util/basic");
var paymentMethodType = t.union([
    t.literal('googlePay'),
    t.literal('applePay'),
]);
var successType = t.literal('success');
var failureType = t.literal('failure');
// Originating FROM web
exports.requestNativePaymentsAvailable = (0, createReqRes_1.createReqRes)('requestNativePaymentsAvailable', t.type({}), basic_1.genericStatusMessage);
exports.requestPayment = (0, createReqRes_1.createReqRes)('requestPayment', t.type({
    paymentMethod: paymentMethodType,
    grandTotal: t.number,
    // Kinda hacky; pass along whatever the client wants to send in addOrder gql.
    orderInput: t.unknown,
    groupOrderInput: t.unknown
}), basic_1.genericStatusMessage);
// Originating FROM native
exports.nativePaymentsAvailable = (0, createReqRes_1.createReqRes)('nativePaymentsAvailable', t.type({
    paymentMethods: t.array(paymentMethodType)
}), basic_1.genericStatusMessage);
exports.nativePaymentResult = (0, createReqRes_1.createReqRes)('nativePaymentResult', t.union([
    t.type({
        resultType: failureType,
        error: t.type({
            message: t.string
        })
    }),
    t.type({
        resultType: successType,
        order: t.union([
            t.type({
                id: t.number,
                uuid: t.string
            }),
            t.type({
                groupOrderId: t.string
            }),
        ])
    }),
]), basic_1.genericStatusMessage);
//# sourceMappingURL=payment.js.map